import Dispatcher from '../../dispatcher';
import HttpRequestConstants from '../../constants/http_request';
import HTTP_REQUEST_KEYS from "../../constants/http_request_keys";

function cartMixedStocksComputeStarted() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.CART_MIXED_STOCKS_COMPUTE_STARTED,
  });
}

function cartMixedStocksComputeSuccess() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.CART_MIXED_STOCKS_COMPUTE_SUCCESS,
  });
}

function cartMixedStocksComputeFailed() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.CART_MIXED_STOCKS_COMPUTE_FAILED,
  });
}

function cartMixedStocksComputeReset() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.RESET_STATUS,
    payload: HTTP_REQUEST_KEYS.CART_MIXED_STOCKS_COMPUTE,
  });
}

export {
  cartMixedStocksComputeStarted,
  cartMixedStocksComputeSuccess,
  cartMixedStocksComputeFailed,
  cartMixedStocksComputeReset
};
